import React from 'react';

interface DiffusedBackgroundProps {
	image: string;
	alt: string;
	blurAmount?: number;
	opacity?: number;
	scale?: number;
	children?: React.ReactNode;
	className?: string;
	foregroundClassName?: string;
	backgroundClassName?: string;
}

/**
 * DiffusedBackground component that displays an image in the foreground with a
 * blurred, scaled version of the same image in the background.
 */
const DiffusedBackground: React.FC<DiffusedBackgroundProps> = ({
	image,
	alt,
	blurAmount = 8,
	opacity = 0.5,
	scale = 1.1,
	children,
	className = '',
	foregroundClassName = '',
	backgroundClassName = '',
}) => {
	return (
		<div className={`relative overflow-hidden flex flex-col justify-center ${className}`}>
			<div
				className={`absolute inset-0 ${backgroundClassName}`}
				style={{
					backgroundImage: `url(${image})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					filter: `blur(${blurAmount}px)`,
					opacity: opacity,
					transform: `scale(${scale})`,
				}}
				aria-hidden="true"
			/>
			<div className={`relative z-10 ${foregroundClassName}`}>
				{children || <img src={image} alt={alt} className="w-full h-auto" />}
			</div>
		</div>
	);
};

export default DiffusedBackground;